import { FC, MouseEvent } from 'react';
import { CONVERSATION_ROUTE_PATH, CONVERSATION_TAB_PARAM, useConversationLink } from '@/entities/conversations';
import type { ExpertReportFeedbackItem } from '@/entities/expert-report';
import { buildEvaluationTargetKey, EVALUATION_TARGET_PARAM } from '@/features/DialogDataSection';
import { useAppNavigate } from '@/shared/lib';

type Props = {
  item: ExpertReportFeedbackItem;
};

/**
 * Ссылка на диалог, в котором сделана правка: карточка открывается на нужном заключении
 * и наводится на правленый элемент. Переход в том же окне запоминает адрес списка —
 * по нему «← Назад» возвращает в «Обратную связь»; клик с модификатором остаётся за браузером,
 * который открывает адрес в новом окне.
 */
export const FeedbackConversationLink: FC<Props> = ({ item }) => {
  const navigate = useAppNavigate();
  const buildLink = useConversationLink();

  // Правка комментария ведёт к правилу, всякая другая — к блоку
  const target =
    item.commentChanged && item.ruleId !== null
      ? buildEvaluationTargetKey('rule', item.ruleId)
      : buildEvaluationTargetKey('block', item.blockId);

  const query = {
    [CONVERSATION_TAB_PARAM]: `expert-report-${item.expertReportId}`,
    [EVALUATION_TARGET_PARAM]: target,
  };
  const { to, state } = buildLink(item.conversationId, query);

  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    if (event.metaKey || event.ctrlKey || event.shiftKey) return;
    event.preventDefault();
    navigate(CONVERSATION_ROUTE_PATH, { id: String(item.conversationId) }, { query, state });
  };

  return (
    <a href={to} className="text-primary underline" onClick={handleClick}>
      {item.conversationId}
    </a>
  );
};
